export enum Endpoints {
  CONTACTS_METIERS = "contacts-metiers",
  COMMUNES = "communes",
  COMMUNES_ASSOCIEES_DELEGUEES = "communes-associees-deleguees",
  EXPORT_PERMANENCE = "export-permanence",
  PERIMETRES = "perimetres",
  PERIMETRES_AVEC_COMMUNES = "perimetres-avec-communes",
  TERRITOIRES = "territoires",
  TERRITOIRES_AVEC_PERIMETRES = "territoires-avec-perimetres",
  AFFECTER_POSTES = "affecter-poste",
  METIERS = "metiers",
  POSTES = "postes",
  CREATION_EN_MASSE = "creation-en-masse",
}
